import { useAppDispatch } from 'hooks';

import { Box, Text, useColorModeValue } from '@chakra-ui/react';

import RadioInput from 'components/fields/auto/RadioInput';

import getRadioYesNo from 'helpers/getRadioYesNo';

import { SECTIONS } from 'views/auto_form/constants';

import { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';

import { changeVehicleAccidentBenefitsQuestion } from 'reducers/autoPersonalFormReducer';

const AccidentBenefitsQuestions = ({
  vehicle,
  index,
}: {
  vehicle: APIPersonalAutoApplicationFormVehicle;
  index: number;
}) => {
  const dispatch = useAppDispatch();
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const onQuestionChange = (
    name: 'question_1' | 'question_2' | 'question_3',
    value: boolean,
  ) => {
    dispatch(changeVehicleAccidentBenefitsQuestion({ name, index, value }));
  };

  return (
    <Box mt={4} pt={4} borderTop="1px solid" borderColor={borderColor}>
      <Text fontWeight="bold" fontSize="l" mb={2}>
        Accident Benefits Questions
      </Text>
      <Box mt="10px" pl="5px">
        <RadioInput
          label="Have you explained to the customer the Accident Benefits options available including which benefits are included/mandatory and which are optional?"
          subLabel={`Vehicle ${index + 1}`}
          section={SECTIONS.VEHICLES}
          options={[
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
          ]}
          value={getRadioYesNo(vehicle.accident_benefits_questions.question_1)}
          onChange={(value: string) => {
            onQuestionChange('question_1', value === 'true');
          }}
          required
          stacked
        />
      </Box>

      <Box mt="15px" pl="5px">
        <RadioInput
          label="Have you confirmed that the Accident Benefits options reflect the customers' informed choices for all drivers listed on the policy?"
          subLabel={`Vehicle ${index + 1}`}
          section={SECTIONS.VEHICLES}
          options={[
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
          ]}
          value={getRadioYesNo(vehicle.accident_benefits_questions.question_2)}
          onChange={(value: string) => {
            onQuestionChange('question_2', value === 'true');
          }}
          required
          stacked
        />
      </Box>

      <Box mt="15px" mb="10px" pl="5px">
        <RadioInput
          label="Have you explained to the customer that as of July 1, 2026, the automobile insurer will generally be the first payor for most medical, rehabilitation, and attendant care expenses (excluding prescription medications)?"
          subLabel={`Vehicle ${index + 1}`}
          section={SECTIONS.VEHICLES}
          options={[
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
          ]}
          value={getRadioYesNo(vehicle.accident_benefits_questions.question_3)}
          onChange={(value: string) => {
            onQuestionChange('question_3', value === 'true');
          }}
          required
          stacked
        />
      </Box>
    </Box>
  );
};

export default AccidentBenefitsQuestions;
